import type {
  OperationsNode,
  OperationsScheduleNode,
} from '../types/operations.types'
import { isScheduleNode } from './nodeTypes'

/**
 * The parent of `nodeId`, or null when it is a root.
 *
 * Needed because an edit can be triggered from a grid row that is not the
 * currently selected node, so the selection's own ancestor path does not
 * necessarily describe it.
 */
export const findNodeParent = (
  nodes: OperationsNode[],
  nodeId: string
): OperationsScheduleNode | null => {
  for (const node of nodes) {
    if (!isScheduleNode(node)) {
      continue
    }
    if (node.children.some((child) => child.id === nodeId)) {
      return node
    }
    const found = findNodeParent(node.children, nodeId)
    if (found) {
      return found
    }
  }
  return null
}
